export function formatMonthlyLabel(
  fromDate: string,
  options?: { hideYear?: boolean }
): string {
  const date = new Date(fromDate);

  return date.toLocaleString('en-US', {
    month: 'long',
    ...(options?.hideYear ? {} : { year: 'numeric' }),
    timeZone: 'Asia/Kolkata',
  });
}
